import {create} from "zustand/react";

type Severity = 'success' | 'info' | 'warning' | 'error';

interface NotificationState {
    open: boolean,
    message: string,
    severity: Severity
}

interface NotificationStore extends NotificationState {
    openNotification: (message: string, severity: Severity) => void,
    closeNotification: () => void
}

export const useNotificationStore = create<NotificationStore>()((set) => ({
    open: false,
    message: "",
    severity: "info",
    openNotification: (message, severity) => set(() => ({open: true, message, severity})),
    closeNotification: () => set(() => ({open: false})),
}));

export const useNotification = () => {
    const {openNotification} = useNotificationStore();
    return {open: openNotification};
}